import { useSetRecoilState } from 'recoil';
import spinner from 'recoil/atoms/spinner';
import Api from 'utils/api';
import { forceDownload } from 'utils/common';


const useVoyageDocs = () => {
    const setSpinner = useSetRecoilState(spinner);

    const downloadManifest = (type?: string) => (id: number) => {
        setSpinner(true);
        Api.voyages.manifest(id, type)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadBLs = (type: string, company?: number) => (id: number) => {
        setSpinner(true);
        Api.voyages.downloadBL(id, type, company)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadECs = (id: number) => {
        setSpinner(true);
        Api.voyages.ec(id)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadInvoices = (company?: number, format?: string) => (id: number) => {
        setSpinner(true);
        Api.voyages.invoices(id, company, format)
            .then(() => setSpinner(false))
    };

    const downloadSI = (company?: number) => (id: number) => {
        setSpinner(true);
        Api.voyages.shippingInstructions(id, company)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadDismantledList = (id: number) => {
        setSpinner(true);
        Api.voyages.unmovables(id)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadED = (company: number) => (id: number) => {
        setSpinner(true);
        Api.voyages.downloadED(id, company)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    // TODO optimize dupes
    const downloadDocPackage = (company?: number) => (id: number) => {
        setSpinner(true);
        Api.voyages.downloadDocPackage(id, company)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadCargoLists = (type: string, company?: number) => (id: number) => {
        setSpinner(true);
        Api.voyages.cargoLists(id, type, company)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadTallymanList = (id: number) => {
        setSpinner(true);
        Api.voyages.tallymanList(id)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const downloadDeliveryList = (id: number) => {
        setSpinner(true);
        Api.voyages.deliveryList(id)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    return {
        downloadManifest,
        downloadBLs,
        downloadECs,
        downloadInvoices,
        downloadSI,
        downloadDismantledList,
        downloadED,
        downloadDocPackage,
        downloadCargoLists,
        downloadTallymanList,
        downloadDeliveryList,
    }
};

export default useVoyageDocs;
